package com.vizio.redwolf.auth.model

data class UpdateEmailV2RequestInfo(val accessToken: String, val email: String, val reCaptchaToken: String? = null)